import {
  Component,
  Input,
  ChangeDetectionStrategy,
  ViewEncapsulation, Output, EventEmitter, OnInit
} from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

import { FocusDirective } from '../../components/focus/focus.directive';
import { HelpService } from './help.service';

@Component({
  selector: 'td-wb-help-mobile-article',
  templateUrl: 'help-mobile-article.component.html',
  styleUrls: ['help-mobile-article.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateDirective,
    FocusDirective
  ],
  encapsulation: ViewEncapsulation.None
})
export class HelpMobileArticleComponent implements OnInit {
  @Input() articleId: string;
  @Input() articleContent: string;
  @Input() hasFocus: boolean;

  @Output() readonly indexId: EventEmitter<string> = new EventEmitter<string>();
  constructor(private helpService: HelpService) {
  }

  ngOnInit(): void {
    if (this.hasFocus) {
      this.helpService.scrollToArticle(this.articleId);
    }
  }

  backToIndex(): false {
    this.indexId.emit(this.articleId);
    return false;
  }
}
